import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel, useStateManager } from "@bcm-dev/bcms-vite";
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import PageContainer from 'components/shared/containers/PageContainer';
import { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import ContentSubheaderView from 'components/shared/views/ContentSubheaderView';
import PageContentView from 'components/shared/views/PageContentView';
import ProfilePicker from 'components/shared/widgets/ProfilePicker';
import Classes, { Profile } from "model";
import React from 'react';
import "./mobile.css";
import "./styles.css";
import TransparentIFramePageContainer from "./components/TransparentIFramePageContainer";


/**
 * @function PaymentsPage
 * @return {React.Component}
 * @note - Branding for this page is being added to the window object so captures can utilize the set value in state code
 * @exported true
 * @description The main component for PaymentsPage  
 */
export default function PaymentsPage(props) {
  const model = useModel();
  const context = useBCMSContext();

  const { defaultView } = props ?? {};

  BCMSRecord.globalControllerFor(Classes, context);

  // Branding options needed for captures
  const { options } = model.branding ?? {};
  const { cashflow_central_abi22: cfcEnabled, cfc25_courseID_abi22: cfcCourse } = options ?? {};

  const cfcIsValid = cfcEnabled === "true" && cfcCourse !== null && cfcCourse !== "";

  const data = getDefaultPageData();
  const ui = getDefaultPageUI(options, defaultView);

  window.BRANDING = { "rxp17_abi22": options.rxp17_abi22 };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    options,
    demos: model.demos,
    cfcIsValid,

    onChange: value => {
      BCMSStateManagerCRUD.init(state)
        .update(["data", "selected"], value)
        .submit(setState);
    },

    onSelect: evt => {
      const profile = Profile.initByID(state.data.selected),
        isBusiness = profile.type === "business";

      BCMSStateManagerCRUD.init(state)
        .update(["ui", "showCFC"], cfcIsValid && isBusiness)
        .submit(setState);
    }
  });

  return (
    <>
      {ui.showCFC && <TransparentIFramePageContainer />}
      <PageContainer className="payments-page integrated-product-page" ignoreTrigger={true} state={{ data, ui }} controller={controller}>
        <PageContent />
      </PageContainer> 
    </>
  );
}

const getDefaultPageData = () => ({
  "selected": Profile.firstInstanceOf().id
});

const getDefaultPageUI = (options, defaultView) => {
  const profile = Profile.firstInstanceOf(),
    isBusiness = profile.type === "business",

    showCFC = (defaultView !== undefined && defaultView === "cfc25") ||
      (options.cashflow_central_abi22 === "true" && (options.cfc25_courseID_abi22 !== "" && options.cfc25_courseID_abi22 !== null) && isBusiness);

  return {
    "showCFC": showCFC
  };
}

function PageContent(props) {
  const { options, demos, ui, data, onChange, onSelect, cfcIsValid } = useStateManager() ?? {};

  const label = options.payments_label_abi22 ?? "Payments";
  const paymentDemo = demos.RXP17 ? "RXP17" : "RXP22";

  const subheaderText = options.payments_subheader_abi22;
  const hasSubheaderText = subheaderText ? true : false;

  return (
    <PageContentView>
      {options.multiprofile_abi22 === "true" &&
        <ProfilePicker profiles={Profile.initAll()} ui={{}} onChange={onChange} onSelectClick={onSelect} disableBusiness={!cfcIsValid}
          profileID={data.selected} />}

      <CenterContentContainer>
        <ContentHeaderView text={label} />
        {hasSubheaderText && <ContentSubheaderView text={subheaderText} />}

        <div className={`iframe-container flex-container flex-horizontal justify-center ${ui.showCFC ? "cfc25-iframe-active" : ""}`}>
          {/* iFrame for RXP17 goes here */}
          {!ui.showCFC && <ExternalIframe className="payments-iframe" demo={paymentDemo} key="PaymentsPage" />}
          {ui.showCFC && <ExternalIframe className="payments-iframe cfc25-iframe" demo="CFC25" key="PaymentsPage_CFC" />}
        </div>
      </CenterContentContainer>
    </PageContentView>
  );
}